var _path, _path2, _g, _path3, _g2, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisits(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1328 14.5219C9.78781 14.5219 9.50781 14.2419 9.50781 13.8969V11.7827C9.50781 11.4377 9.78781 11.1577 10.1328 11.1577C10.4778 11.1577 10.7578 11.4377 10.7578 11.7827V13.8969C10.7578 14.2419 10.4778 14.5219 10.1328 14.5219Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13293_2370",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 3,
    width: 18,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.80371 3.81641H18.4619V12.4089H1.80371V3.81641Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13293_2370)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.05371 9.49391C5.03371 10.5697 7.53038 11.1589 10.1287 11.1589C12.732 11.1589 15.2312 10.5697 17.212 9.49391V6.99224C17.212 5.92974 16.3529 5.06641 15.2954 5.06641H4.97871C3.91704 5.06641 3.05371 5.92641 3.05371 6.98391V9.49391ZM10.1287 12.4089C7.17454 12.4089 4.32704 11.6939 2.11288 10.3972C1.92121 10.2856 1.80371 10.0806 1.80371 9.85807V6.98391C1.80371 5.23724 3.22788 3.81641 4.97871 3.81641H15.2954C17.042 3.81641 18.462 5.24057 18.462 6.99224V9.85807C18.462 10.0806 18.3437 10.2856 18.1529 10.3972C15.9387 11.6939 13.0887 12.4089 10.1287 12.4089Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13293_2370",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 1,
    width: 8,
    height: 5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.59131 1.6665H13.6746V5.06309H6.59131V1.6665Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13293_2370)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0496 5.06317C12.7046 5.06317 12.4246 4.78317 12.4246 4.43817V4.13317C12.4246 3.46234 11.8788 2.9165 11.208 2.9165H9.05798C8.38714 2.9165 7.84131 3.46234 7.84131 4.13317V4.43817C7.84131 4.78317 7.56131 5.06317 7.21631 5.06317C6.87131 5.06317 6.59131 4.78317 6.59131 4.43817V4.13317C6.59131 2.77317 7.69798 1.6665 9.05798 1.6665H11.208C12.568 1.6665 13.6746 2.77317 13.6746 4.13317V4.43817C13.6746 4.78317 13.3946 5.06317 13.0496 5.06317Z",
    fill: "currentColor"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9659 18.1163H5.29919C3.57002 18.1163 2.11419 16.7655 1.98336 15.0405L1.82502 12.9497C1.79919 12.6055 2.05752 12.3047 2.40169 12.2788C2.74752 12.2663 3.04586 12.5105 3.07252 12.8555L3.23002 14.9455C3.31169 16.0222 4.22002 16.8663 5.29919 16.8663H14.9659C16.045 16.8663 16.9542 16.0222 17.035 14.9455L17.1934 12.8555C17.22 12.5105 17.5259 12.2655 17.8642 12.2788C18.2084 12.3047 18.4659 12.6055 18.44 12.9497L18.2817 15.0405C18.1509 16.7655 16.695 18.1163 14.9659 18.1163Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisits);
export default __webpack_public_path__ + "static/media/visits.5e1c2b2ed14d0ad590b8f1a06324f5a1.svg";
export { ForwardRef as ReactComponent };